import React from 'react';
import { connect } from 'react-redux';
import { Button, Dropdown, Grid, Header, Icon } from 'semantic-ui-react';
import { showSuccessAlert, confirmModal } from '../../redux/actions/modals';
import { newDepot, newGameTitle, loadDepot, loadNoteAcceptorModel, loadCabinetType, fetchOperators, getAssets, loadAsset, updateCabinetType, loadCategory, loadGameTitle, loadManufacturer, newAsset, newCategory, newCabinetType, newManufacturer, updateAsset, updateCategory, updateGameTitle, updateManufacturer, updateDepot, newNoteAcceptorModel, updateNoteAcceptorModel } from '../../redux/actions/index';
import { getCategories, getCabinetTypes, getNoteAcceptorModels, getGameTitles, getDepots, getGroupings, getManufacturers, getStatuses, getVariants } from '../../redux/actions/index';
import { showInstallHistoryModal } from '../../redux/actions/modals';
import EGMFilters from '../assetAdmin/AssetAdminFilters';
import EGMTree from '../assetAdmin/AssetAdminTree';
import DataGrid from '../shared/DataGrid';
import BaseSettings from '../systemAdmin/BaseSettings';
import OptionsList from '../systemAdmin/OptionsList';
import { handleDownload } from '../../helpers/downloads';
import { getAssetsDownload } from '../../api/egm';

class AssetAdminView extends BaseSettings {

  constructor() {
    super()
    this.state = {
      ...this.state, // spread in parent's state
      searchParams: {
        selectedOperator: null,
        selectedGrouping: 0,
        selectedCategory: -1,
        searchText: "",
        selectedManufacturer: -1,
        selectedGameTitle: -1,
        selectedCabinetType: -1,
        selectedNoteAcceptorModel: -1,
        selectedStatus: -1,
        selectedVariant: -1,
        selectedDepot: -1
      },
      filters: { 
        manufacturers: [],
        categories: [],
        gameTitles: [],
        cabinetTypes: [],
        statuses: [],
        selectedStatuses: [],
        variants: [],
        depots: [],
        noteAcceptorModels: [],
        groupings: [],
      },
      selectedNode: { id: null, name: null, type: null },
      grid: { data: [], rowDef: [], headerDef: []},
      selectedOptions: [],
      assets: [],
      loading: false,
      doQuestion: false,
      questionText: ""
    }
  }


  handleSelection = (name, value) => {
    this.setState({ searchParams: {...this.state.searchParams, [name]: value } })
  }

  componentDidMount = () => {
    if (this.props.operators.length === 1) {
      this.setState( { searchParams: {...this.state.searchParams, selectedOperator: this.props.operators[0].value }}, () => this.updateFilters())
    }
  }

  handleRefresh = async () => {
    const {
        selectedOperator,
        selectedGrouping,
        selectedCategory,
        searchText,
        selectedManufacturer,
        selectedGameTitle,
        selectedCabinetType,
        selectedNoteAcceptorModel,
        selectedStatus,
        selectedVariant,
        selectedDepot
      } = this.state.searchParams;
    
    await this.setState({ loading: true })

    await getAssets(
      selectedOperator,
      selectedCategory,
      selectedManufacturer,
      selectedCabinetType,
      selectedGameTitle,
      selectedNoteAcceptorModel,
      selectedStatus,
      selectedVariant,
      selectedGrouping,
      searchText,
      selectedDepot
    ).then(
      assets => this.setState({ assets, loading: false }),
      () => this.setState({ loading: false })
    );
  }

  handleNew = (selectedOptions, selectedNode, grid = null) => {
    this.setState({ selectedOptions, changed: [], selectedNode, grid })
  }

  onNewManufacturerClick = () => {
    newManufacturer(this.state.searchParams.selectedOperator).then(selectedOptions => this.handleNew(selectedOptions, { id: 0, name: "New Manufacturer", type: "MU"} ))
  }

  onNewCategoryClick = () => {
    newCategory(this.state.searchParams.selectedOperator).then(selectedOptions => this.handleNew(selectedOptions, { id: 0, name: "New Category", type: "MT"} ))
  }

  onNewGameTitleClick = () => {
    newGameTitle(this.state.searchParams.selectedOperator).then(selectedOptions => this.handleNew(selectedOptions, { id: 0, name: "New Game Title", type: "GT"} ))
  }
  onNewAssetClick = () => {
    newAsset(this.state.searchParams.selectedOperator).then(selectedOptions => this.handleNew(selectedOptions, { id: 0, name: "New Machine Asset", type: "MA" } ))
  }

  onNewCabinetTypeClick = () => {
    newCabinetType(this.state.searchParams.selectedOperator).then(selectedOptions => this.handleNew(selectedOptions, { id: 0, name: "New Cabinet Type", type: "CB" } ))
  }

  onNewDepotClick = () => {
    newDepot(this.state.searchParams.selectedOperator).then(selectedOptions => this.handleNew(selectedOptions, { id: 0, name: "Depot", type: "DP" } ))
  }

  onNewNoteAcceptorClick = () => {
    newNoteAcceptorModel(this.state.searchParams.selectedOperator).then(selectedOptions => this.handleNew(selectedOptions, { id: 0, name: "Note Acceptor Model", type: "NA" } ))
  }

  loadNode = async (item) => {
    switch (item.type) {
      case "MU":
        return loadManufacturer(item.id)

      case "GT":
        return loadGameTitle(item.id)

      case "MA":
        return loadAsset(item.id)

      case "MT":
        return loadCategory(item.id)

      case "DP":
        return loadDepot(item.id)

      case "CB":
        return loadCabinetType(item.id)

      case "NA":
        return loadNoteAcceptorModel(item.id);

      default: 
        return { options: [], grid: null }
    }
  }

  handleNodeClick = (item) => {
    this.loadNode(item).then(response => {
      const { doQuestion, questionText } = response;
      this.setState({ doQuestion, questionText}, () => {
        this.handleNew(response.options, item, response.grid)
      })
    })
  }

  handleReload = () => {
    const options = this.getAll(this.state.selectedOptions)
    const { selectedNode } = this.state;
    updateAsset(selectedNode.id, this.state.searchParams.selectedOperator, false, options).then(selectedOptions => this.setState({ selectedOptions }))
  }

  findById = (array, id) => {
    for (const node of array) {
      if (node.id === id) return node;
      if (node.children) {
        const child = this.findById(node.children, id);
        if (child) return child;
      }
    }
  }

  handleSave = async () => {
    const changed = this.getAll(this.state.selectedOptions);
    const { selectedNode } = this.state;
    
    const callback = async (doUpdate) => {
      await this.setState({ loading: true })
      await this.updateRequest(selectedNode, changed, doUpdate).then(
        id => {
          this.setState({ changed: [], loading: false}, () => {
            this.props.showSuccessAlert(selectedNode.id > 0 ? "Your changes were saved successfully!" : "Item successfully created!")
            this.handleRefresh().then(() => {
              const node = this.findById(this.state.assets, id) || this.state.selectedNode;
              this.handleNodeClick(node)
            })
          });
        },
        () => this.setState({ loading: false })
      )
    }

    if (this.state.doQuestion) {
      this.props.confirmModal(this.state.questionText, true, () => callback(true), () => callback(false), true);
    } else {
      callback(true);
    }

  }

  onOperatorChange = (event, data) => {
    this.setState({ searchParams: {...this.state.searchParams, selectedOperator: data.value } }, () => this.updateFilters())
  }

  setFilters = (filter) => {
    this.setState({ filters: {...this.state.filters, ...filter }})
  }

  getManufacturers = () => {
    getManufacturers(this.state.searchParams.selectedOperator).then(manufacturers => {
      this.setFilters({ manufacturers })
    })
  }

  getCategories = () => {
    getCategories(this.state.searchParams.selectedOperator).then(categories => {
      this.setFilters({ categories })
    })
  }  

  getNoteAcceptorModels = () => {
    getNoteAcceptorModels(this.state.searchParams.selectedOperator).then(noteAcceptorModels => {
      this.setFilters({ noteAcceptorModels })
    })
  }  

  getDepots = () => {
    getDepots(this.state.searchParams.selectedOperator).then(depots => {
      this.setFilters({ depots })
    })
  }  

  getCabinetTypes = () => {
    getCabinetTypes(this.state.searchParams.selectedOperator).then(cabinetTypes => {
      this.setFilters({ cabinetTypes })
    })
  }

  getGameTitles = () => {
    getGameTitles(this.state.searchParams.selectedOperator).then(gameTitles => {
      this.setFilters({ gameTitles });
    })
  }

  updateFilters = () => {
    this.getManufacturers();
    this.getCategories();
    this.getNoteAcceptorModels();
    this.getDepots();
    this.getCabinetTypes();
    this.getGameTitles();

  getVariants().then(variants => {
      this.setFilters({ variants })
    })

    getGroupings().then(groupings => {
      this.setFilters({ groupings })
    })

    getStatuses().then(statuses => {
        const selectedStatus = this.state.searchParams.selectedStatus.length > 0 ? this.state.searchParams.selectedStatus : statuses.map(x => x.value);
        this.setState({ searchParams: {...this.state.searchParams, selectedStatus } }, () => this.setFilters({ statuses }))
    })

  }

  updateRequest = async (selectedNode, changed, doUpdate = true) => {
    switch (selectedNode.type) {
      case "MU":
        return await updateManufacturer(selectedNode.id, this.state.searchParams.selectedOperator, changed, () => this.getManufacturers())

      case "GT":
        return await updateGameTitle(selectedNode.id, this.state.searchParams.selectedOperator, changed, () => this.getGameTitles())

      case "MA":
        return await updateAsset(selectedNode.id, this.state.searchParams.selectedOperator, true, changed)

      case "MT":
        return await updateCategory(selectedNode.id, this.state.searchParams.selectedOperator, changed, () => this.getCategories())

      case "DP":
        return await updateDepot(selectedNode.id, this.state.searchParams.selectedOperator, changed, () => this.getDepots())

      case "CB":
        return await updateCabinetType(selectedNode.id, this.state.searchParams.selectedOperator, changed, doUpdate, () => this.getCabinetTypes())

      case "NA":
        return await updateNoteAcceptorModel(selectedNode.id, this.state.searchParams.selectedOperator, changed, () => this.getNoteAcceptorModels())

      default:
        break;
    }
  }

  handleDownload = () => {
    const {
      selectedOperator,
      selectedGrouping,
      selectedCategory,
      searchText,
      selectedManufacturer,
      selectedGameTitle,
      selectedCabinetType,
      selectedNoteAcceptorModel,
      selectedStatus,
      selectedVariant,
      selectedDepot
    } = this.state.searchParams;

    this.setState({ loading: true }, () => {
      getAssetsDownload(
        selectedOperator,
        selectedCategory,
        selectedManufacturer,
        selectedCabinetType,
        selectedGameTitle,
        selectedNoteAcceptorModel,
        selectedStatus,
        selectedVariant,
        selectedGrouping,
        searchText,
        selectedDepot
      ).then(
        response => this.setState({ loading: false }, () => handleDownload('Asset Admin Export', response)),
        () => this.setState({ loading: false })
      );
    })
  }

  render() {
    return (
      <Grid columns="2" className="height-100 gs-flex-container-vertical">
        <Grid.Row className="flex-stretch">
          <Grid.Column computer="8" largeScreen="7" widescreen="6" className="gs-flex-container-vertical">
            <div className="p-1">
              <EGMFilters 
                onChange={this.handleSelection}
                onOperatorChange={this.onOperatorChange}
                onRefresh={this.handleRefresh}
                loading={this.state.loading}
                filters={this.state.filters}
                searchParams={this.state.searchParams}
                disableDownload={this.state.assets.length < 1}
                onDownloadClick={this.handleDownload}
              />
            </div>
            <div className="table-overflow flex-stretch-vertical mt-1">
              <EGMTree selectedNode={this.state.selectedNode} assets={this.state.assets} onClick={this.handleNodeClick} />
            </div>
          </Grid.Column>
          <Grid.Column computer="8" largeScreen="9" widescreen="10" className="gs-flex-container-vertical">
            <div className="table-overflow flex-stretch-vertical p-1 mb-1">
              {this.state.selectedNode.id !== null &&
                <>
                  <Header>
                    {this.state.selectedNode.name}
                    { (this.state.grid !== null && this.state.grid.data.length > 0) && <Button compact color="blue" content="Install History" floated="right" onClick={() => this.props.showInstallHistoryModal(this.state.grid) } /> }
                  </Header>
                  <OptionsList options={this.mapChanged(this.state.selectedOptions)} onChange={this.handleChangeValue} />
                </>
              }
            </div>
            <div className="mt-1">
            <Dropdown
              text='New'
              icon='add'
              floating
              positive
              as={Button}
              labeled
              button
              color='green'
              className='icon'
              labelPosition='right'
              disabled={!this.state.searchParams.selectedOperator || this.state.loading}
              loading={this.state.loading}
            >
              <Dropdown.Menu>
                <Dropdown.Header icon='add' content='Select Item to Create' />
                <Dropdown.Item onClick={this.onNewDepotClick}>Depot</Dropdown.Item>
                <Dropdown.Item onClick={this.onNewManufacturerClick}>Manufacturer</Dropdown.Item>
                <Dropdown.Item onClick={this.onNewCategoryClick}>Category</Dropdown.Item>
                <Dropdown.Item onClick={this.onNewAssetClick}>Machine Asset</Dropdown.Item>
                <Dropdown.Item onClick={this.onNewCabinetTypeClick}>Cabinet Type</Dropdown.Item>                
                <Dropdown.Item onClick={this.onNewGameTitleClick}>Game Title/Pack</Dropdown.Item>                
                <Dropdown.Item onClick={this.onNewNoteAcceptorClick}>Note Acceptor</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
            <Button icon positive labelPosition='right' loading={this.state.loading} disabled={this.state.selectedNode.id === 0 ? !this.isAllValid(this.state.selectedOptions) || this.state.loading : !this.isValid() || this.state.loading} onClick={this.handleSave}>
              Save Changes
              <Icon name='save' />
            </Button>
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
};


const mapStateToProps = state => {
	return {
    operators: state.operators.filter(x => x.value !== -1),
    logIn: state.logIn
  };
};

export default connect(mapStateToProps, { showInstallHistoryModal, fetchOperators, confirmModal, showSuccessAlert })(AssetAdminView);

